module.exports = __webpack_public_path__ + "img/19.d9b489b6.jpg";